
import { defineComponent } from "vue"
import type { SwiperOptions } from "swiper"
import indexSwiperMixin from "@/mixins/index-swiper"
import galleryMixin from "@/mixins/gallery"

export default defineComponent({
  mixins: [indexSwiperMixin, galleryMixin],

  props: {
    year: { type: Number, required: true },
  },

  data: () => ({
    chunkSize: 4,
  }),

  computed: {
    photosChunks (): string[][] {
      const chunks: string[][] = []
      const { chunkSize } = this

      for (let i = 0; i < this.items.length; i += chunkSize)
        chunks.push(this.items.slice(i, i + chunkSize))

      return chunks
    },

    swiperOptions (): SwiperOptions {
      return {
        spaceBetween: 20,
        slidesPerView: "auto",
        navigation: {
          prevEl: `#${this.prevId}`,
          nextEl: `#${this.nextId}`,
          disabledClass: "index-swiper-nav-disabled",
        },
      }
    },
  },
})
